export default __webpack_public_path__ + "static/media/videobg.d0e56186.jpg";